// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__222EP","right":"Footer_right__105hA","buttons":"Footer_buttons__3zH1l"};